import styled from 'styled-components';

const Gradient = styled.div`
  position: absolute;
  top: 0;
  height: 20px;
  width: 100%;
  background: ${({ theme }) => theme.commons.header.gradient};
`;

export default Gradient;
